module.exports = __webpack_public_path__ + "static/media/IMG_1319.c91e127b.jpg";